import { CustomerDTO } from "../DTO/customerDTO";
import { Address } from "./address";

export class Customer{
    public id! : number;
    public name! : string;
    public canCreateMoovs! : boolean;
    public addressList!: Address[];
    public premierPartnerIdList!: number[];
    public deleted! : boolean;
    public billingCustomerId?:string;
    public added! : Date;
    public detamoovEmailAddress?:string;
    public tag?:string; //json {"integrations": [{"name":"a", "id":1},{"name":"b", "id":2},{"name":"c", "id":3}], "otherTag": "value"}
    constructor(){
        this.addressList = new Array();
        this.premierPartnerIdList = new Array();
    }

    public static mapFromDTO(param:CustomerDTO):Customer{ 
        if (!param) throw new Error("parameter is null")
        let obj = new Customer();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.addressList = param.addressList.map(dto=>Address.mapFromDTO(dto));
            obj.premierPartnerIdList = param.premierPartnerIdList;
            obj.deleted = param.deleted;
            obj.billingCustomerId = param.billingCustomerId;
            obj.canCreateMoovs = param.canCreateMoovs;
            if(param.added) obj.added = new Date(param.added);
            obj.detamoovEmailAddress = param.detamoovEmailAddress;
            if(param.tag) obj.tag = Object.assign(new Tag(), JSON.parse(param.tag));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:Customer):CustomerDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new CustomerDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.addressList = param.addressList.map(adr=>Address.mapToDTO(adr));
            dto.premierPartnerIdList = param.premierPartnerIdList;
            dto.deleted = param.deleted;
            dto.billingCustomerId = param.billingCustomerId;
            dto.canCreateMoovs = param.canCreateMoovs;
            if(param.added) dto.added = param.added.toISOString();
            dto.detamoovEmailAddress = param.detamoovEmailAddress;
            if(param.tag) dto.tag = JSON.stringify(param.tag);
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    public addAddress(address:Address){
        //currently we only support one address per customer. address.type=0
        this.addressList.push(address)
    }

    get address(){
        //currently we only support one address per customer. address.type=0
        return this.addressList?.length>0?this.addressList[0]:undefined;
    }

    get formattedAddress(){
        //currently we only support one address per customer. address.type=0
        return this.addressList?.length>0?this.addressList[0].formattedAddress:undefined;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }
}

export class Tag{
    public integrations:string[] = [];
}